import { writable } from 'svelte-persistent-store/dist/local';
import { writable as SessionWritable } from 'svelte-persistent-store/dist/session';
export const cartStore = writable('cart', []);
export const autoSaveStore = SessionWritable('autoSaveStore', false);
